import { useParams } from "react-router-dom"
import { Annonce } from "../../models/AnnonceModel"
import { useEffect, useState } from "react"
import { getAnnonceByNumAnnonce } from "../../services/Annonce_service"
import logo_alo from '../../image/alo_logo.png'
import { FaDownload, FaEnvelope, FaSearch } from 'react-icons/fa'
import { format } from "date-fns"

interface CertificateCheckPropTypes {}
export function CertificateCheck ({}: CertificateCheckPropTypes){

    const { numAnnonce } = useParams()

    const [ annonce, setAnnonce ] = useState<Annonce | null>( null )
    const [ numAnnonceSearch, setNumAnnonceSearch ] = useState< string | undefined >( numAnnonce )

    const getAnnonceByNum = async ( numAnnonce: string | undefined ) => {
        try {
            const annonca_data = await getAnnonceByNumAnnonce( numAnnonce || '' )
            if( annonca_data ) setAnnonce( annonca_data );
            else setAnnonce( null )
        } catch (error) {
            console.log( error )
        }
    }

    useEffect(() => {
        getAnnonceByNum(numAnnonce)
    }, [])

    const handleDisplay = () => {
        getAnnonceByNum( numAnnonceSearch )
    }

    return (
        <div className="certificate-checking-page">

            <div className="certificate-checking-logo-container">
                <img src = { logo_alo } alt = "Logo sur fond vert d' ALO" />
            </div>

            <div className = "certificate-checking-header">
                <span> Vérification des attestations de parution </span>
                <div className="certificate-checking-search-bar">
                    <input
                        type="text"
                        name=""
                        id=""
                        value = { numAnnonceSearch }
                        onChange = { event => setNumAnnonceSearch( event.target.value )}
                    />
                    <button className = "search-button" onClick = { handleDisplay }>
                        <i> <FaSearch size = { 20 } /> </i>
                        <span> Afficher </span>
                    </button>
                </div>
            </div>

            {
                annonce
                ?
                <>
                    
                    <div className="subtitile">
                        <span> Annonce légale validée le { annonce?.createdAt ? format( annonce.createdAt, "dd/MM/yyyy") : "" } par { annonce?.nomJal }, pour une publication le { annonce?.dateParrution ? format( annonce.dateParrution, "dd/MM/yyyy") : "" } </span>
                    </div>

                    <div className="info-container">

                        <div className="info-title">
                            <span> JOURNAL D'ANNONCES LEGALES HABILITÉ </span>
                        </div>

                        <div className="info-item">
                            <div className="info-key"> TITRE </div>
                            <div className="info-value"> { annonce?.nomJal } </div>
                        </div>

                        <div className="info-item">
                            <div className="info-key"> DÉPARTEMENT </div>
                            <div className="info-value"> { annonce?.departmentCode } </div>
                        </div>

                        <div className="info-item">
                            <div className="info-key"> DATE DE PUBLICATION </div>
                            <div className="info-value"> { annonce?.dateParrution ? format( annonce.dateParrution, "dd/MM/yyyy") : "" } </div>
                        </div>

                    </div>

                    <div className="info-container">

                        <div className="info-title">
                            <span> RENSEIGNEMENTS DU CONTACT </span>
                        </div>

                        <div className="info-item">
                            <div className="info-key"> ADRESSE </div>
                            <div className="info-value"> 9 Rue de Condé - B3 33000 Bordeaux </div>
                        </div>

                        <div className="info-item">
                            <div className="info-key"> MAIL </div>
                            <div className="info-value"> service-clients@annonce-legale-officielle.fr </div>
                        </div>

                        <div className="info-item">
                            <div className="info-key"> TÉLÉPHONE </div>
                            <div className="info-value"> 0188 844 844 </div>
                        </div>

                        <div className="info-item">
                            <div className="info-key"> FAX </div>
                            <div className="info-value"></div>
                        </div>

                        <a href = 'mailto:site.terrier@gmail.com' >
                            <button>
                                <i> <FaEnvelope /> </i>
                                <span> CONTACTER LE JOURNAL </span>
                            </button>
                        </a>

                    </div>

                    <div className="info-container">

                        <div className="info-title">
                            <span> RENSEIGNEMENTS À PROPOS DE L'ANNONCE </span>
                        </div>

                        <div className="info-item">
                            <div className="info-key"> ENTREPRISE </div>
                            <div className="info-value"> { annonce?.denomination } </div>
                        </div>

                        <div className="info-item">
                            <div className="info-key"> ÉVÈNEMENT </div>
                            <div className="info-value"> { annonce?.type_annonce } </div>
                        </div>

                    </div>

                    <div className="info-container">

                        <div className="info-title">
                            <span> ATTESTATION </span>
                        </div>

                        <div className="info-item">
                            <div className="info-key"> VERSION DU DOCUMENT </div>
                            <div className="info-value"> 1 </div>
                        </div>
                    
                        <a download href = { `${ process.env.REACT_APP_API_URL }/download-attestation/${ annonce?.pdfAttestationAlo?.split('/')?.[2] }`}   >
                            <button>
                                <i> <FaDownload /> </i>
                                <span>  TÉLÉCHARGER L'ATTESTATION CERTIFIÉE </span>
                            </button>
                        </a>hotfix/verified-attestation

                    </div>

                    <div className="subtitile">
                        <span> Attestation certifiée </span>
                    </div>

                    <iframe src = { `${ process.env.REACT_APP_API_BASE }/${ annonce?.pdfAttestationAlo }`} style={{ width: '100%', margin: 'auto', height: 800 }}>
                        L'affichage du document n'est pas compatible avec votre navigateur
                    </iframe>
                </>
                :
                <div className="no-certificate">
                    <span> Le numéro saisi ne correspond à aucune attestation. Merci de bien vouloir vérifier le numéro </span>
                </div>
            }

        </div>
    )
}